// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hocW","content":"styles_content__2as5O","tableWrap":"styles_tableWrap__2q1es"};